import { toOptions } from './ArrayUtil';

export const schoolYearsData = [
  '未就学児',
  '小学校1年生',
  '小学校2年生',
  '小学校3年生',
  '小学校4年生',
  '小学校5年生',
  '小学校6年生',
  '中学校1年生',
  '中学校2年生',
  '中学校3年生',
  '特に高校受験に向けた中学生の受験生',
  '高校1年生',
  '高校2年生',
  '高校3年生',
  '特に大学受験に向けた高校生の受験生',
];
export const schoolYearsOptions = toOptions(schoolYearsData);

export function toShortSchoolYear(schoolYear: string) {
  if (schoolYear === '特に高校受験に向けた中学生の受験生') return '高校受験';
  if (schoolYear === '特に大学受験に向けた高校生の受験生') return '大学受験';
  return schoolYear.replace('学', '').replace('校', '').replace('年生', '');
}
